export class QuestionBankQuestionReorderModel {
    id: string;
    zOrder: string;
}
